import type { IconSvgObject } from './types';

const GreaterThanIcon: IconSvgObject = [
  ["path", { d: "M7 4L17 12L7 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default GreaterThanIcon;
